import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';

export interface DraftSurveyConfirmationData {
  text: string;
  headingText: string;
  confirmButtonLabel?: string;
  declineButtonLabel?: string;
}

@Component({
  selector: 'ps-ui-draft-survey-confirmation-modal',
  templateUrl: './draft-survey-confirmation-modal.component.html',
  styleUrls: ['./draft-survey-confirmation-modal.component.css'],
})
export class DraftSurveyConfirmationModalComponent implements OnInit {
  public text: string = '';
  public confirmButtonLabel: string = '';
  public declineButtonLabel: string = '';
  public headingText: string = '';
  constructor(
    private _modalRef: ModalRef<DraftSurveyConfirmationModalComponent, string>,
    @Inject(ModalData)
    private _modalData: DraftSurveyConfirmationData
  ) {}

  ngOnInit(): void {
    this.text = this._modalData.text || '';
    this.headingText = this._modalData.headingText || '';
    this.confirmButtonLabel =
      this._modalData.confirmButtonLabel || 'Yes, delete the survey';
    this.declineButtonLabel =
      this._modalData.declineButtonLabel || 'No, keep the survey as a draft';
  }

  close(msg: string) {
    this._modalRef.close(msg);
  }
}
